import { axiosSwagger } from "@/axios";



export const state = {
    pending: {
        loading: false,
        data: [],
        total: 0,
    }

}


export const getters = {
}


export const mutations = {
    loading: (state, loading) => {
        state.pending.loading = loading;
    },
    setData: (state, data) => {
        state.pending.data = data;
    },
    setTotal: (state, total) => {
        state.pending.total = total;
    }
}


export const actions = {
    // FILE POSTED
    async readFilePostedByDeliveryUnitId({ commit }) {
        commit("loading", true);

        const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

        return await axiosSwagger
        .get(`/api/FilePosting/Posted/${userData?.deliveryUnit?.id}`)
        .then((response) => {
            const customData = ( response.data );

            commit("setData", customData);
            commit("setTotal", customData.length);
            commit("loading", false);

            return response;
        })
        .catch(() => {
            commit("loading", false);
        });
    },
    async readTotalDUPendingPostResponse({ commit }) {
        const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

        return await axiosSwagger
        .get(`/api/FilePosting/Posted/${userData?.deliveryUnit?.id}`)
        .then((response) => {
            const customData = ( response.data );

            commit("setTotal", customData.length);

            return response;
        });
    },
}


// eslint-disable-next-line no-unused-vars
const modifyData = (arrayData) => {
    if(arrayData?.length ?? false){
        return arrayData.filter( e => {
            // e filter data if classified and if user is not the one who upload
            const isClassified = e?.isClassified || false;
            const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;
            
            if(!isClassified){
                return true;
            }
            else if(isClassified && e.fileManager.applicationUserId !== userData?.userId){
                return false
            }
        
            return true;
        });
    }
  
    return [];
};